import React from 'react';
import { I18nUtils } from '../../../../../i18n/I18nUtils';
import { MachineUpdateContent } from './MachineUpdateContent';
import { PsPage } from '../../../../shared/components/ps-page/PsPage';
import { BreadcrumbsManagerInstance } from '../../../../shared/breadcrumbs/BreadcrumbsManager';
import { Breadcrumbs } from '../../../../shared/breadcrumbs/Breadcrumbs';

export class MachineUpdateScreen extends React.Component {

    constructor(props) {
        super(props);

        BreadcrumbsManagerInstance.build([
            Breadcrumbs.MY_CONTRACTORS,
            Breadcrumbs.MY_CONTRACTORS_MACHINES,
            Breadcrumbs.MY_CONTRACTORS_MACHINES_DETAIL,
        ]);

        this.state = {
            breadcrumbs: BreadcrumbsManagerInstance.breadcrumbs(),
        };
    }

    render() {
        const { breadcrumbs } = this.state;

        return (
            <PsPage title={I18nUtils.tr('TR_MI_MAQUINA_PARA_MI_CONTRATISTA')} breadcrumbs={breadcrumbs}>
                <MachineUpdateContent
                    id={Number(this.props.match.params.id)}
                    appendBreadcrumb={this.appendBreadcrumb}
                />
            </PsPage>
        );
    }

    appendBreadcrumb = (machine) => {
        BreadcrumbsManagerInstance.finishLoading({
            id: Breadcrumbs.MY_CONTRACTORS_MACHINES_DETAIL.id,
            url: this.props.location.pathname,
            description: machine.shortDescription(),
        });

        this.setState({
            breadcrumbs: [...BreadcrumbsManagerInstance.breadcrumbs()],
        });
    };
}

MachineUpdateScreen.propTypes = {};

MachineUpdateScreen.defaultProps = {};



// WEBPACK FOOTER //
// ./src/app/my-contractors/machine/form/update/MachineUpdateScreen.jsx